import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AttributeCommand from '@ckeditor/ckeditor5-basic-styles/src/attributecommand';

const Slide = 'addSlide';

export default class SlideEditing extends Plugin {
    init() {
        const editor = this.editor;
        // Allow bold attribute on text nodes.
        editor.model.schema.extend('$text', { allowAttributes: Slide });

        // Build converter from model to view for data and editing pipelines.

        editor.conversion.attributeToElement({
            model: Slide,
            view: 'slide',
        });

        // Create bold command.
        editor.commands.add(Slide, new AttributeCommand(editor, Slide));

        // Set the Ctrl+S keystroke.
        editor.keystrokes.set('CTRL+S', Slide);
    }
}